import { Component } from 'preact';
import notifyMounted from '../notify-mounted';

/**
 * The PanelGraph component handlers the rendering of a panel graph, which is not
 * rendered via Preact components, but with D3. It handles resizing too.
 *
 * props:
 * - graphFactory: factory function which returns a Graph object
 * - data: The data to be passed to the graph factory
 * - opts: extra options object to be passed to the graph factory
 */
class PanelGraph extends Component {

	constructor(props, context) {
		super(props, context);

		this.graphContainer = null;
		this.graphContainerWidth = -1;
		this.graph = null;
	}

	update(factory, data, opts) {
		this.graph = factory(data, this.graphContainer.getBoundingClientRect(), opts);
		this.graph.render(this.graphContainer);
	}

	componentDidMount() {
		this.update(this.props.graphFactory, this.props.data, this.props.opts);

		this.resizeHandlerId = this.context.resize.addHandler(() => {

			const dim = this.graphContainer.getBoundingClientRect();

			// Only re-render the graph if the container width has actually changed.
			if (dim.width !== this.graphContainerWidth) {
				this.graphContainerWidth = dim.width;
				this.graphContainer.style.height = dim.height + 'px';
				this.graphContainer.innerHTML = '';
				this.graph.render(this.graphContainer);
				this.graphContainer.style.height = '';
			}

		});

		// This fixes behaviour on chrome (desktop + android) where touchmove events stop
		// We just need to add a listener for the  touchstart event on the document,
		// it doesn't actually need to do anything.
		this.documentTouchHandler = () => {};
		document.addEventListener('touchstart', this.documentTouchHandler);
	}

	componentWillUnmount() {
		this.context.resize.removeHandler(this.resizeHandlerId);
		document.removeEventListener('touchstart', this.documentTouchHandler);
	}

	shouldComponentUpdate() {
		return false;
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.data !== this.props.data ||
			nextProps.opts !== this.props.opts ||
			nextProps.graphFactory !== this.props.graphFactory) {
			this.update(nextProps.graphFactory, nextProps.data, nextProps.opts);
		}
	}

	render() {
		return <div class="hw_panel_graph" ref={el => { this.graphContainer = el; }} />;
	}

}

export default notifyMounted(PanelGraph);



// WEBPACK FOOTER //
// ./components/panelgraph/index.js